/**
 * -----------------------------------------------------------------------------
 * It renders a man payment card illustration.
 */
export function ManPaymentCardIllustrationSVG() {
  return (
    <svg fill="none" height="200" viewBox="0 0 185 200" width="185">
      <path
        className="fill-gray-200"
        d="M97.65 172.532c46.499 0 84.195-2.201 84.195-4.916 0-2.715-37.696-4.915-84.195-4.915-46.499 0-84.194 2.2-84.194 4.915s37.695 4.916 84.194 4.916Z"
      />
      <path
        className="fill-primary-200"
        d="M52.89 102.518c9.184-9.185 9.184-24.076 0-33.26-9.185-9.185-24.076-9.185-33.26 0-9.184 9.184-9.184 24.075 0 33.26 9.184 9.184 24.075 9.184 33.26 0Z"
      />
      <path
        className="fill-primary-200"
        d="M52.89 102.518c9.184-9.185 9.184-24.076 0-33.26-9.185-9.185-24.076-9.185-33.26 0-9.184 9.184-9.184 24.075 0 33.26 9.184 9.184 24.075 9.184 33.26 0Z"
        opacity={0.5}
      />
      <path
        className="fill-primary-200"
        d="M55.73 89.209c1.834-10.752-5.396-20.955-16.148-22.789-10.751-1.834-20.954 5.395-22.788 16.147-1.834 10.752 5.395 20.955 16.147 22.789 10.752 1.834 20.955-5.395 22.789-16.147Z"
        opacity={0.2}
      />
      <path
        className="fill-primary-200"
        d="M56.674 87.78c.733-10.472-7.161-19.554-17.632-20.287-10.47-.733-19.553 7.161-20.286 17.632-.733 10.47 7.161 19.553 17.632 20.286 10.47.733 19.553-7.161 20.286-17.632Z"
      />
      <path
        className="fill-primary-200"
        d="M56.674 87.78c.733-10.472-7.161-19.554-17.632-20.287-10.47-.733-19.553 7.161-20.286 17.632-.733 10.47 7.161 19.553 17.632 20.286 10.47.733 19.553-7.161 20.286-17.632Z"
        opacity={0.5}
      />
      <path
        className="fill-primary-200"
        d="m44.07 84.078 1.237 5.362a1.523 1.523 0 0 1-.2 1.212 1.596 1.596 0 0 1-1.011.716l-4.716 1.09.868 3.774a1.507 1.507 0 0 1-.208 1.203 1.523 1.523 0 0 1-1.012.686 1.598 1.598 0 0 1-1.229-.191 1.51 1.51 0 0 1-.712-.99l-.868-3.817-4.677 1.081a1.537 1.537 0 0 1-1.19-.2 1.52 1.52 0 0 1-.716-.99 1.546 1.546 0 0 1 .2-1.198 1.52 1.52 0 0 1 .99-.708l10.942-2.523-.512-2.228-10.913 2.515a1.542 1.542 0 0 1-1.198-.187 1.521 1.521 0 0 1-.708-1.003l-1.233-5.341a1.59 1.59 0 0 1 1.19-1.907l4.655-1.072-.869-3.778a1.543 1.543 0 0 1 .183-1.186 1.558 1.558 0 0 1 1.06-.729 1.525 1.525 0 0 1 1.185.2 1.551 1.551 0 0 1 .703.994l.869 3.774 4.776-1.095a1.574 1.574 0 0 1 1.22.204 1.51 1.51 0 0 1 .721.978 1.646 1.646 0 0 1-1.22 1.95l-10.943 2.522.478 2.215 10.904-2.514a1.578 1.578 0 0 1 1.22.204 1.496 1.496 0 0 1 .734.977Z"
      />
      <path
        d="m44.07 84.078 1.237 5.362a1.523 1.523 0 0 1-.2 1.212 1.596 1.596 0 0 1-1.011.716l-4.716 1.09.868 3.774a1.507 1.507 0 0 1-.208 1.203 1.523 1.523 0 0 1-1.012.686 1.598 1.598 0 0 1-1.229-.191 1.51 1.51 0 0 1-.712-.99l-.868-3.817-4.677 1.081a1.537 1.537 0 0 1-1.19-.2 1.52 1.52 0 0 1-.716-.99 1.546 1.546 0 0 1 .2-1.198 1.52 1.52 0 0 1 .99-.708l10.942-2.523-.512-2.228-10.913 2.515a1.542 1.542 0 0 1-1.198-.187 1.521 1.521 0 0 1-.708-1.003l-1.233-5.341a1.59 1.59 0 0 1 1.19-1.907l4.655-1.072-.869-3.778a1.543 1.543 0 0 1 .183-1.186 1.558 1.558 0 0 1 1.06-.729 1.525 1.525 0 0 1 1.185.2 1.551 1.551 0 0 1 .703.994l.869 3.774 4.776-1.095a1.574 1.574 0 0 1 1.22.204 1.51 1.51 0 0 1 .721.978 1.646 1.646 0 0 1-1.22 1.95l-10.943 2.522.478 2.215 10.904-2.514a1.578 1.578 0 0 1 1.22.204 1.496 1.496 0 0 1 .734.977Z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        className="fill-primary-200"
        d="M86.446 67.185c5.852-6.924 4.982-17.28-1.942-23.132-6.924-5.851-17.28-4.981-23.132 1.943-5.851 6.924-4.981 17.28 1.943 23.131 6.924 5.852 17.28 4.982 23.131-1.942Z"
      />
      <path
        className="fill-primary-200"
        d="M86.446 67.185c5.852-6.924 4.982-17.28-1.942-23.132-6.924-5.851-17.28-4.981-23.132 1.943-5.851 6.924-4.981 17.28 1.943 23.131 6.924 5.852 17.28 4.982 23.131-1.942Z"
        opacity={0.5}
      />
      <path
        className="fill-primary-200"
        d="M84.533 65.36c4.85-5.867 4.026-14.555-1.841-19.405-5.867-4.85-14.555-4.026-19.405 1.841-4.85 5.867-4.025 14.555 1.842 19.405 5.866 4.85 14.554 4.025 19.404-1.841Z"
        opacity={0.2}
      />
      <path
        className="fill-primary-200"
        d="M84.95 65.504c4.436-5.806 3.327-14.11-2.479-18.547-5.806-4.438-14.11-3.328-18.547 2.478-4.437 5.805-3.328 14.11 2.478 18.547 5.806 4.437 14.11 3.328 18.547-2.478Z"
      />
      <path
        className="fill-primary-200"
        d="M84.95 65.504c4.436-5.806 3.327-14.11-2.479-18.547-5.806-4.438-14.11-3.328-18.547 2.478-4.437 5.805-3.328 14.11 2.478 18.547 5.806 4.437 14.11 3.328 18.547-2.478Z"
        opacity={0.5}
      />
      <path
        className="fill-primary-200"
        d="m79.334 57.937-.933 3.725a1.046 1.046 0 0 1-.513.673 1.118 1.118 0 0 1-.868.126l-3.253-.82-.66 2.605a1.052 1.052 0 0 1-.512.678 1.07 1.07 0 0 1-.834.125 1.118 1.118 0 0 1-.699-.508 1.069 1.069 0 0 1-.13-.842l.664-2.649-3.257-.795a1.073 1.073 0 0 1-.677-.503 1.055 1.055 0 0 1-.13-.838 1.069 1.069 0 0 1 .503-.687 1.081 1.081 0 0 1 .843-.121l7.599 1.906.39-1.546-7.577-1.902a1.054 1.054 0 0 1-.681-.499 1.036 1.036 0 0 1-.122-.842l.93-3.713a1.104 1.104 0 0 1 1.345-.803l3.222.807.66-2.605a1.088 1.088 0 0 1 1.381-.812 1.037 1.037 0 0 1 .67.5 1.071 1.071 0 0 1 .125.837l-.66 2.606 3.3.829a1.099 1.099 0 0 1 .695.517 1.06 1.06 0 0 1 .139.833 1.12 1.12 0 0 1-.521.695 1.107 1.107 0 0 1-.869.13l-7.603-1.906-.382 1.538 7.573 1.897a1.1 1.1 0 0 1 .695.517 1.038 1.038 0 0 1 .147.847Z"
      />
      <path
        d="m79.334 57.937-.933 3.725a1.046 1.046 0 0 1-.513.673 1.118 1.118 0 0 1-.868.126l-3.253-.82-.66 2.605a1.052 1.052 0 0 1-.512.678 1.07 1.07 0 0 1-.834.125 1.118 1.118 0 0 1-.699-.508 1.069 1.069 0 0 1-.13-.842l.664-2.649-3.257-.795a1.073 1.073 0 0 1-.677-.503 1.055 1.055 0 0 1-.13-.838 1.069 1.069 0 0 1 .503-.687 1.081 1.081 0 0 1 .843-.121l7.599 1.906.39-1.546-7.577-1.902a1.054 1.054 0 0 1-.681-.499 1.036 1.036 0 0 1-.122-.842l.93-3.713a1.104 1.104 0 0 1 1.345-.803l3.222.807.66-2.605a1.088 1.088 0 0 1 1.381-.812 1.037 1.037 0 0 1 .67.5 1.071 1.071 0 0 1 .125.837l-.66 2.606 3.3.829a1.099 1.099 0 0 1 .695.517 1.06 1.06 0 0 1 .139.833 1.12 1.12 0 0 1-.521.695 1.107 1.107 0 0 1-.869.13l-7.603-1.906-.382 1.538 7.573 1.897a1.1 1.1 0 0 1 .695.517 1.038 1.038 0 0 1 .147.847Z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        className="fill-primary-600"
        d="M33.93 155.774h-.434v4.903h.434v-4.903Z"
      />
      <path
        className="fill-primary-950"
        d="M33.93 155.774h-.434v4.903h.434v-4.903Z"
        opacity={0.1}
      />
      <path
        className="fill-primary-600"
        d="M161.804 116.932h-.434v6.718h.434v-6.718Zm0 10.244h-.434v3.643h.434v-3.643Z"
      />
      <path
        className="fill-primary-950"
        d="M161.804 116.932h-.434v6.718h.434v-6.718Zm0 10.244h-.434v3.643h.434v-3.643Z"
        opacity={0.1}
      />
      <path
        className="fill-primary-600"
        d="M153.754 87.803H41.551a6.535 6.535 0 0 0-6.535 6.536v65.678a6.535 6.535 0 0 0 6.535 6.535h112.203a6.535 6.535 0 0 0 6.535-6.535V94.339a6.535 6.535 0 0 0-6.535-6.536Z"
      />
      <path
        className="fill-primary-950"
        d="M153.754 87.803H41.551a6.535 6.535 0 0 0-6.535 6.536v65.678a6.535 6.535 0 0 0 6.535 6.535h112.203a6.535 6.535 0 0 0 6.535-6.535V94.339a6.535 6.535 0 0 0-6.535-6.536Z"
        opacity={0.2}
      />
      <path
        className="fill-primary-600"
        d="M140.01 115.225a8.109 8.109 0 0 0 0-16.214h-10.465a8.108 8.108 0 0 0 0 16.214h10.465Zm-70.698-.004h-19.31a2.814 2.814 0 0 0-2.815 2.814v12.623a2.814 2.814 0 0 0 2.814 2.814h19.31a2.814 2.814 0 0 0 2.815-2.814v-12.623a2.814 2.814 0 0 0-2.814-2.814Z"
      />
      <path
        d="M69.312 115.221h-19.31a2.814 2.814 0 0 0-2.815 2.814v12.623a2.814 2.814 0 0 0 2.814 2.814h19.31a2.814 2.814 0 0 0 2.815-2.814v-12.623a2.814 2.814 0 0 0-2.814-2.814Z"
        fill="#fff"
        opacity={0.3}
      />
      <path
        className="fill-primary-600"
        d="M82.673 97.018H49.181a1.992 1.992 0 1 0 0 3.982h33.492a1.992 1.992 0 1 0 0-3.982Z"
      />
      <path
        d="M82.673 97.018H49.181a1.992 1.992 0 1 0 0 3.982h33.492a1.992 1.992 0 1 0 0-3.982Z"
        fill="#fff"
        opacity={0.3}
      />
      <path
        className="fill-primary-600"
        d="M65.174 142.53H50.11a2.923 2.923 0 0 0-2.923 2.923v2.731a2.922 2.922 0 0 0 2.923 2.922h15.064a2.922 2.922 0 0 0 2.922-2.922v-2.731a2.923 2.923 0 0 0-2.922-2.923Z"
      />
      <path
        d="M65.174 142.53H50.11a2.923 2.923 0 0 0-2.923 2.923v2.731a2.922 2.922 0 0 0 2.923 2.922h15.064a2.922 2.922 0 0 0 2.922-2.922v-2.731a2.923 2.923 0 0 0-2.922-2.923Z"
        fill="#fff"
        opacity={0.3}
      />
      <path
        className="fill-primary-600"
        d="M91.844 142.53H76.781a2.923 2.923 0 0 0-2.923 2.923v2.731a2.922 2.922 0 0 0 2.923 2.922h15.063a2.922 2.922 0 0 0 2.923-2.922v-2.731a2.923 2.923 0 0 0-2.923-2.923Z"
      />
      <path
        d="M91.844 142.53H76.781a2.923 2.923 0 0 0-2.923 2.923v2.731a2.922 2.922 0 0 0 2.923 2.922h15.063a2.922 2.922 0 0 0 2.923-2.922v-2.731a2.923 2.923 0 0 0-2.923-2.923Z"
        fill="#fff"
        opacity={0.3}
      />
      <path
        className="fill-primary-600"
        d="M118.52 142.53h-15.064a2.923 2.923 0 0 0-2.922 2.923v2.731a2.922 2.922 0 0 0 2.922 2.922h15.064a2.922 2.922 0 0 0 2.922-2.922v-2.731a2.923 2.923 0 0 0-2.922-2.923Z"
      />
      <path
        d="M118.52 142.53h-15.064a2.923 2.923 0 0 0-2.922 2.923v2.731a2.922 2.922 0 0 0 2.922 2.922h15.064a2.922 2.922 0 0 0 2.922-2.922v-2.731a2.923 2.923 0 0 0-2.922-2.923Z"
        fill="#fff"
        opacity={0.3}
      />
      <path
        className="fill-primary-600"
        d="M145.19 142.53h-15.063a2.923 2.923 0 0 0-2.923 2.923v2.731a2.923 2.923 0 0 0 2.923 2.922h15.063a2.923 2.923 0 0 0 2.923-2.922v-2.731a2.923 2.923 0 0 0-2.923-2.923Z"
      />
      <path
        d="M145.19 142.53h-15.063a2.923 2.923 0 0 0-2.923 2.923v2.731a2.923 2.923 0 0 0 2.923 2.922h15.063a2.923 2.923 0 0 0 2.923-2.922v-2.731a2.923 2.923 0 0 0-2.923-2.923Z"
        fill="#fff"
        opacity={0.3}
      />
      <path
        className="fill-red-200"
        d="M116.323 59.309c-1.03 2.905-2.172 5.714-3.383 8.524a73.2 73.2 0 0 1-4.212 8.311c-.213.343-.434.686-.665 1.03l-.169.255-.23.317c-.156.2-.304.374-.434.543-.548.61-1.127 1.19-1.737 1.737-1.16 1.073-2.341 2.046-3.535 3.005a109.481 109.481 0 0 1-7.382 5.372l-1.515-1.88 6.383-6.293a105.687 105.687 0 0 0 3.079-3.157c.482-.525.95-1.063 1.337-1.558.095-.122.178-.244.252-.348l.091-.148.126-.225c.169-.3.347-.59.512-.9 1.329-2.496 2.502-5.21 3.631-7.963a325.972 325.972 0 0 0 3.256-8.281l4.595 1.659Z"
      />
      <path
        className="fill-primary-600"
        d="M117.543 57.216c.986 2.883-4.807 11.364-4.807 11.364l-5.532-3.079a64.477 64.477 0 0 1 3.335-7.73c1.936-3.664 5.923-3.72 7.004-.555Z"
      />
      <path
        d="M117.543 57.216c.986 2.883-4.807 11.364-4.807 11.364l-5.532-3.079a64.477 64.477 0 0 1 3.335-7.73c1.936-3.664 5.923-3.72 7.004-.555Z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        className="fill-primary-600"
        d="M117.625 57.576c-1.242-.595-2.67-.095-4.177 2.284-1.507 2.38-2.788 6.353-2.927 7.487l2.219 1.228s5.346-7.833 4.885-10.999Z"
        opacity={0.31}
      />
      <path
        className="fill-primary-600"
        d="M113.795 55.01s-4.134 9.722-1.155 27.826h17.218c.212-2.645-1.003-15.537 1.98-27.991a43.961 43.961 0 0 0-5.741-.73 64.247 64.247 0 0 0-7.317 0c-1.682.171-3.348.47-4.985.895Z"
      />
      <path
        d="M113.795 55.01s-4.134 9.722-1.155 27.826h17.218c.212-2.645-1.003-15.537 1.98-27.991a43.961 43.961 0 0 0-5.741-.73 64.247 64.247 0 0 0-7.317 0c-1.682.171-3.348.47-4.985.895Z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        className="fill-red-200"
        d="m135.954 159.965-2.549 2.284-4.859-5.055 2.554-2.284 4.854 5.055Zm-8.741 4.755h-3.217l-.417-7.456h3.217l.417 7.456Z"
      />
      <path
        className="fill-red-200"
        d="m128.551 157.194 2.501 2.606 2.553-2.284-2.501-2.606-2.553 2.284Zm-1.755.074h-3.217l.217 3.843h3.218l-.218-3.843Z"
      />
      <path
        className="fill-primary-600"
        d="M112.64 82.836s-3.391 23.475-4.546 36.25c-.929 10.252 21.238 40.818 21.238 40.818l4.286-4.034s-16.188-27.405-14.942-38.816c1.207-11.052 5.298-34.231 5.298-34.231l-11.334.013Z"
      />
      <path
        className="fill-nuetral-500"
        d="M112.64 82.836s-3.391 23.475-4.546 36.25c-.929 10.252 21.238 40.818 21.238 40.818l4.286-4.034s-16.188-27.405-14.942-38.816c1.207-11.052 5.298-34.231 5.298-34.231l-11.334.013Z"
        opacity={0.5}
      />
      <path
        className="fill-primary-950"
        d="M118.676 117.067c.621-5.693 2.011-14.612 3.205-21.916-.626-1.225-2.38-3.704-2.38-3.704-1.572 5.432-4.989 25.911-.113 53.567 5.081 8.19 9.944 14.903 9.944 14.903l.665-10.561c-4.694-8.832-12.185-24.399-11.321-32.289Z"
        opacity={0.2}
      />
      <path
        className="fill-primary-600"
        d="M118.763 82.836s-.304 24.599.217 33.818c.569 10.092 3.435 43.528 3.435 43.528h5.897s-.178-32.62.169-42.607c.387-10.856 1.385-34.74 1.385-34.74h-11.103Z"
      />
      <path
        className="fill-nuetral-500"
        d="M118.763 82.836s-.304 24.599.217 33.818c.569 10.092 3.435 43.528 3.435 43.528h5.897s-.178-32.62.169-42.607c.387-10.856 1.385-34.74 1.385-34.74h-11.103Z"
        opacity={0.5}
      />
      <path
        className="fill-primary-950"
        d="M123.826 164.351h3.617a.228.228 0 0 1 .239.217l.178 2.861a.56.56 0 0 1-.163.404.577.577 0 0 1-.401.17c-1.259-.022-1.863-.096-3.452-.096-.977 0-5.137.104-6.488.104-1.35 0-1.303-1.337-.742-1.459 2.566-.543 5.749-1.302 6.661-2.006a.905.905 0 0 1 .551-.195Z"
      />
      <path
        className="fill-primary-950"
        d="m132.702 161.337 3.1-2.089a.29.29 0 0 1 .356 0l2.371 2.393a.483.483 0 0 1 .038.582.48.48 0 0 1-.151.143c-1.98 1.524-3.408 2.675-4.537 3.943-1.303 1.481-2.007 1.694-5.046 1.694-1.407 0-2.202-1.186-1.629-1.368 5.064-1.603 3.709-2.302 4.942-4.651.129-.258.32-.481.556-.647Z"
      />
      <path
        className="fill-red-200"
        d="m93.79 86.119-3.357.117.704 2.631s3.509.313 3.821-.747l-1.168-2Zm-6.978 1.684 2.353 1.373 1.972-.309-.704-2.631-3.621 1.567Z"
      />
      <path
        className="fill-primary-600"
        d="M127.991 57.92c-.357 2.049.117 6.947 1.875 12.618a82.765 82.765 0 0 1 1.69-14.456v-.026c-1.129-.113-3.222-.06-3.565 1.863Z"
        opacity={0.31}
      />
      <path
        className="fill-red-200"
        d="M125.659 45.873c-.543 2.354-1.156 6.67.434 8.251 0 0-.686 1.95-5.063 1.95-4.812 0-2.254-1.95-2.254-1.95 2.649-.625 2.649-2.575 2.254-4.403l4.629-3.847Z"
      />
      <path
        className="fill-primary-600"
        d="m120.908 56.065-1.303 1.385.639 1.338 1.038.048.885-1.277-1.259-1.494Z"
      />
      <path
        className="fill-red-200"
        d="m123.774 47.441-2.74 2.267c.099.428.16.864.182 1.303 1.008-.144 2.423-1.247 2.567-2.298.076-.42.074-.852-.009-1.272Z"
      />
      <path
        className="fill-primary-950"
        d="M119.948 37.892c-1.645.56-2.961 4.924-1.042 6.08 1.92 1.155 4.169-7.144 1.042-6.08Z"
      />
      <path
        className="fill-red-200"
        d="M126.688 43.407c-.982 3.04-1.398 4.877-3.378 6.123a4.167 4.167 0 0 1-5.884-1.467 4.156 4.156 0 0 1-.53-2.172c.039-2.922 1.637-7.421 5.002-7.986a4.214 4.214 0 0 1 4.937 3.328 4.225 4.225 0 0 1-.147 2.174Z"
      />
      <path
        className="fill-primary-950"
        d="M129.12 38.327c-.982 2.37 1.302.39.712 3.204-.382 1.833-3.691 6.223-4.968 5.823-1.277-.4-1.264-3.513.365-5.714.938-1.264-1.09-2.697-5.645-2.545-4.555.152-7.308-2.41-1.255-4.29 0 0-2.232 1.303-.908 1.737 1.876.699 13.666-2.966 11.699 1.785Z"
      />
      <path
        className="fill-primary-950"
        d="M128.251 39.412c-.048 0 1.021-.265 1.589-2.171 0 .03-.186 2.84-1.589 2.171Zm-8.524-4.186c-2.801.868-1.641 1.846-.482 2.089l2.657-1.042c-4.038.534-2.175-1.047-2.175-1.047Z"
      />
      <path
        className="fill-red-200"
        d="M127.226 47.12a3.177 3.177 0 0 1-2.171.899c-1.073 0-1.303-1.017-.725-1.868.512-.764 1.685-1.684 2.631-1.272.947.413.977 1.542.265 2.24Z"
      />
      <path
        className="fill-primary-950"
        d="M121.742 43.238c-.065.252-.252.434-.434.39-.183-.043-.248-.273-.183-.525s.252-.434.435-.386c.182.047.247.269.182.52Zm-2.866-.63c-.065.252-.252.434-.434.39-.183-.043-.248-.268-.183-.52s.248-.434.434-.391c.187.043.235.27.183.521Z"
      />
      <path
        className="fill-red-200"
        d="M119.753 42.934a9.815 9.815 0 0 1-1.737 1.889 1.489 1.489 0 0 0 1.155.49l.582-2.38Z"
      />
      <path
        className="fill-primary-950"
        d="M120.231 46.23c-.18 0-.359-.021-.534-.061a.08.08 0 0 1-.047-.035c-.01-.017-.014-.037-.01-.056a.077.077 0 0 1 .091-.057 2.174 2.174 0 0 0 1.841-.434.08.08 0 0 1 .109 0 .079.079 0 0 1 0 .108 2.204 2.204 0 0 1-1.45.535Zm2.649-3.717a.149.149 0 0 1-.139-.092 1.178 1.178 0 0 0-.825-.699.144.144 0 0 1-.057-.02.155.155 0 0 1-.074-.154.157.157 0 0 1 .174-.13 1.461 1.461 0 0 1 1.06.869.145.145 0 0 1 .013.058.132.132 0 0 1-.01.058.144.144 0 0 1-.082.084.154.154 0 0 1-.06.026Zm-4.972-1.151a.153.153 0 0 1-.151-.14.158.158 0 0 1 .033-.112 1.597 1.597 0 0 1 1.277-.595.153.153 0 0 1 .139.165.147.147 0 0 1-.165.139 1.278 1.278 0 0 0-1.016.486.15.15 0 0 1-.117.057Z"
      />
      <path
        className="fill-red-200"
        d="M132.672 57.064c.338.525.621.99.907 1.494a45.468 45.468 0 0 1 2.315 4.568 32 32 0 0 1 2.14 6.683l.044.221.022.109.03.182c.037.243.056.488.056.734a6.458 6.458 0 0 1-.13 1.224 10.305 10.305 0 0 1-.634 1.937 20.69 20.69 0 0 1-1.737 3.131 36.456 36.456 0 0 1-4.29 5.267l-1.889-1.515c1.051-1.833 2.097-3.735 2.974-5.598.432-.89.8-1.81 1.103-2.753.124-.393.209-.797.252-1.207a1.82 1.82 0 0 0 0-.404c0-.039 0-.073-.026-.078-.026-.004 0 0 0-.022l-.026-.086-.052-.178c-.274-.958-.6-1.9-.977-2.823a50.345 50.345 0 0 0-1.255-2.814 66.666 66.666 0 0 0-1.424-2.774c-.243-.46-.5-.917-.756-1.368l-.764-1.303 4.117-2.627Z"
      />
      <path
        d="M122.688 164.906a.864.864 0 0 1-.607-.169.424.424 0 0 1-.096-.408.293.293 0 0 1 .178-.213c.395-.156 1.303.469 1.407.539a.063.063 0 0 1 .028.034.066.066 0 0 1 .002.044.068.068 0 0 1-.019.039.078.078 0 0 1-.037.022 4.115 4.115 0 0 1-.856.112Zm-.377-.664a.284.284 0 0 0-.092 0 .132.132 0 0 0-.056.04.138.138 0 0 0-.026.064.275.275 0 0 0 .052.27c.148.147.569.165 1.146.052a2.584 2.584 0 0 0-1.024-.422v-.004Z"
        fill="#fff"
      />
      <path
        d="M123.527 164.798h-.039c-.322-.191-.799-.869-.726-1.216a.287.287 0 0 1 .274-.23.392.392 0 0 1 .317.104c.326.317.252 1.242.252 1.281a.093.093 0 0 1-.014.036.08.08 0 0 1-.03.025h-.034Zm-.435-1.303h-.034c-.109 0-.135.065-.144.109-.047.23.27.738.547.972a1.675 1.675 0 0 0-.208-1.016.236.236 0 0 0-.165-.065h.004Zm7.526-.412a.571.571 0 0 1-.235-.044.381.381 0 0 1-.23-.269.22.22 0 0 1 .048-.213c.291-.351 1.815-.247 1.989-.234.016 0 .031.006.044.016a.08.08 0 0 1 .025.04.084.084 0 0 1-.004.047.083.083 0 0 1-.031.036 4.074 4.074 0 0 1-1.606.621Zm.92-.634c-.534 0-1.094.052-1.22.204a.077.077 0 0 0-.011.039c0 .014.004.027.011.039a.224.224 0 0 0 .048.102c.024.03.056.053.091.067.243.1.79-.065 1.481-.434l-.4-.017Z"
        fill="#fff"
      />
      <path
        d="M132.185 162.475c-.434 0-1.411-.335-1.485-.682 0-.087 0-.208.209-.308.746-.352 1.324.829 1.35.868a.1.1 0 0 1 0 .078.074.074 0 0 1-.031.032.082.082 0 0 1-.043.012Zm-1.003-.899a.464.464 0 0 0-.213.048c-.091.043-.134.091-.126.134.044.204.747.491 1.208.552-.139-.235-.474-.734-.869-.734Z"
        fill="#fff"
      />
      <path
        className="fill-red-200"
        d="m130.366 80.395-3.188-.56 1.646 3.713s2.923 0 2.792-1.529l-1.25-1.624Zm-5.598 1.303 1.507 3 2.532-1.154-1.646-3.709-2.393 1.863Z"
      />
      <path
        className="fill-primary-600"
        d="m133.879 155.636-4.807 4.529-1.551-1.663 5.502-5.012.856 2.146Z"
      />
      <path
        d="m133.879 155.636-4.807 4.529-1.551-1.663 5.502-5.012.856 2.146Z"
        fill="#fff"
        opacity={0.6}
      />
      <path
        className="fill-primary-600"
        d="M128.546 160.182h-6.37l-.352-2.236 7.031.347-.309 1.889Z"
      />
      <path
        d="M128.546 160.182h-6.37l-.352-2.236 7.031.347-.309 1.889Z"
        fill="#fff"
        opacity={0.6}
      />
      <path
        className="fill-primary-600"
        d="M131.838 54.845c3.04.434 6.153 10.995 6.153 10.995l-6.514 3.613s-2.644-5.02-3.908-8.746c-1.324-3.904 1.016-6.34 4.269-5.862Z"
      />
      <path
        d="M131.838 54.845c3.04.434 6.153 10.995 6.153 10.995l-6.514 3.613s-2.644-5.02-3.908-8.746c-1.324-3.904 1.016-6.34 4.269-5.862Z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        className="fill-primary-950"
        d="m120.908 56.065-1.303 1.385.639 1.338 1.038.048.885-1.277-1.259-1.494Z"
        opacity={0.2}
      />
      <path
        className="fill-primary-600"
        d="M120.357 58.549s-2.471 10.235-2.567 12.363c-.134 2.926 1.09 7.924 1.09 7.924s1.737-4.155 2.093-8.016c.356-3.86.091-10.104.252-12.271h-.868Z"
      />
      <path
        className="fill-primary-950"
        d="M120.357 58.549s-2.471 10.235-2.567 12.363c-.134 2.926 1.09 7.924 1.09 7.924s1.737-4.155 2.093-8.016c.356-3.86.091-10.104.252-12.271h-.868Z"
        opacity={0.2}
      />
      <path
        className="fill-primary-600"
        d="M120.908 56.065a5.64 5.64 0 0 1 .834 2.653s5.419-1.91 5.163-4.711c0 0-.769-.456-1.255-.825 0 0-.182 1.763-4.742 2.883Z"
      />
      <path
        d="M120.908 56.065a5.64 5.64 0 0 1 .834 2.653s5.419-1.91 5.163-4.711c0 0-.769-.456-1.255-.825 0 0-.182 1.763-4.742 2.883Z"
        fill="#fff"
        opacity={0.6}
      />
      <path
        className="fill-primary-600"
        d="M120.908 56.065a7.615 7.615 0 0 0-1.059 2.484s-2.454-1.659-1.716-4.425a9.2 9.2 0 0 1 1.386-.434s-.322 1.789 1.389 2.375Z"
      />
      <path
        d="M120.908 56.065a7.615 7.615 0 0 0-1.059 2.484s-2.454-1.659-1.716-4.425a9.2 9.2 0 0 1 1.386-.434s-.322 1.789 1.389 2.375Z"
        fill="#fff"
        opacity={0.6}
      />
    </svg>
  );
}
